export function getKeyOfProperty(key: string, securityCount: number) {
  if (securityCount === 0) {
    return key;
  }

  return `${key}_${securityCount}`;
}
